import clsx from "clsx"

import { faIcon } from "@utils/faIcon"

import Icon from "@atoms/Icon/Icon"

import styles from "./StatusDot.module.scss"
import { StatusDotProps } from "./StatusDot.types"

export default function StatusDot(props: StatusDotProps) {
    const { colorScheme, size } = props

    return (
        <div
            className={clsx(styles.base, styles[`${size}Size`])}
            style={
                {
                    "--status-color": `var(--${colorScheme}-a9)`,
                } as React.CSSProperties
            }
        >
            <Icon
                icon={faIcon({ name: "circle-small", style: "solid" })}
                size={size === "sm" ? 8 : 10}
                container="fixedHeight"
            />
        </div>
    )
}
